import styled from '@emotion/styled';
import type { PropsWithChildren } from 'react';
import Divider from '@/components/comm/Divider';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

type TitleWithDividerProps = {
  title: string,
  fontSize?: number,
  dividerWidth?: string,
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TitleText = styled.span<{ fontSize?: number }>`
color: ${colors.textPrimary};
font-size: ${({ fontSize = 20 }) => fontSize}px;
font-weight: 700;
line-height: 32px;
@media (max-width: ${breakpointMedium}) {
  font-size: ${({ fontSize }) => fontSize ?? 16}px;
}
`;

const TitleWithDivider = ({ title, fontSize, dividerWidth, children }: PropsWithChildren<TitleWithDividerProps>) => {
  return (
    <Container>
      <TitleText fontSize={fontSize}>{title}</TitleText>
      <Divider
        color={colors.textPrimary}
        size={dividerWidth}
        thick={2}
      />
      {children}
    </Container>
  );
};

export default TitleWithDivider;
